import React from 'react'

import './scss/footer.scss'

export default () => (
	<div className="footer">
		<div className="_ornament">
			<span>* * *</span>
		</div>
		<div className="_logo">
			<a href="https://myscreate.com/" target="_blank" rel="noopener noreferrer">
				<img src="/img/logo.svg" alt="ma-ya's CREATE" width="75" height="37"/>
			</a>
		</div>
		<small className="_notice">
			This is <strong><a href="https://jamstack.org/" target="_blank" rel="noopener noreferrer">Jamstack</a></strong> website, <br />
			has been generated by
			<strong><a href="https://www.gatsbyjs.com/" target="_blank" rel="noopener noreferrer">Gatsby.js</a></strong> /
			<strong><a href="https://www.contentful.com/" target="_blank" rel="noopener noreferrer">Contentful</a></strong> /
			<strong><a href="https://www.netlify.com/" target="_blank" rel="noopener noreferrer">Netlify</a></strong>.
		</small>
		<small className="_copyright">© Copyright 2020 │ ma-ya's CREATE All rights reserved.</small>
	</div>
)
